import axiosInstance from './axiosInstance';

const normalizeList = (data, key) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data[key])) return data[key];
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};

const mapBannerFromApi = (b) => {
  if (!b) return null;
  return {
    id: b.id,
    title: b.title ?? '',
    section: b.section ?? 'banner',
    categoryName: b.category_name ?? b.categoryName ?? '',
    isActive: Boolean(b.is_active ?? b.isActive ?? true),
    imagePath: b.image_path ?? b.imagePath ?? '',
    createdAt: b.created_at ?? b.createdAt,
    updatedAt: b.updated_at ?? b.updatedAt,
  };
};

export const fetchBanners = async (section = 'banner') => {
  const response = await axiosInstance.get('/banners', {
    params: { section },
  });
  const list = normalizeList(response.data, 'banners');
  return list.map(mapBannerFromApi).filter(Boolean);
};

export const createBanner = async ({ file, title = '', section = 'banner', categoryName = '' }) => {
  const formData = new FormData();
  if (file) formData.append('bannerImage', file);
  // Backend insert binds title; never omit it (avoid undefined bind)
  formData.append('title', title ?? '');
  formData.append('section', section);
  if (categoryName) formData.append('category_name', categoryName);

  const response = await axiosInstance.post('/banners', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateBanner = async (id, { file, title, section = 'banner', categoryName, isActive }) => {
  const formData = new FormData();
  if (file) formData.append('bannerImage', file);
  if (title !== undefined) formData.append('title', title);
  if (section !== undefined) formData.append('section', section);
  if (categoryName !== undefined) formData.append('category_name', categoryName);
  if (isActive !== undefined) formData.append('is_active', String(Boolean(isActive)));

  const response = await axiosInstance.put(`/banners/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteBanner = async (id) => {
  await axiosInstance.delete(`/banners/${id}`);
};

